module.exports = __webpack_public_path__ + "static/img/s161.6695b905.png";